import { useEffect, useMemo, useState } from "react";
import { database } from "../../../services/firebase-config";
import { getDocs, collection } from "firebase/firestore";
import styles from "./styles.module.css"

import DataTable from 'react-data-table-component';

export default function ListUsers() {

    let count = 0;

    const [users, setUsers] = useState([]);
    const usersCollectionRef = collection(database, 'users');
    const [updateTable, setUpdateTable] = useState(1);

    function updateTableData() {
        setUpdateTable(updateTable + 1);
        console.log('updateTableData');
    }

    useEffect(() => {
        const getUsers = async () => {
            const data = await getDocs(usersCollectionRef);
            setUsers(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
            console.log('getFirebaseData');

        }
        getUsers();


    }, [updateTable]);


    const columns = [
        {
            name: 'Nome',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Telefone',
            selector: row => row.phone,
            sortable: true,
        }
    ];



    const paginationComponentOptions = {
        rowsPerPageText: 'Usuários por pagina',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const filteredItems = users.filter(
        ebook => ebook.name && ebook.name.toLowerCase().includes(filterText.toLowerCase()),
    );

    const data = filteredItems.map((user) => {
        return {
            name: user.name,
            email: user.email,
            phone: user.phone

        }
    })

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className={styles.filterTable}>
                <label htmlFor="filtro">Buscar: </label>
                <input id='filtro' name='filtro' placeholder='Nome do usuário...' onChange={e => setFilterText(e.target.value)} value={filterText} />
            </div>

        );
    }, [filterText, resetPaginationToggle]);

    return (
        <div className={styles.ListContainer}>

            <div className={styles.ControlsContainer}>
                {subHeaderComponentMemo}
            </div>

            <DataTable
                title="Lista de Usuários"
                pagination
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent="Nenhum usuário encontrado"
                columns={columns}
                data={data} />

        </div>
    );
}